export interface IfeaturedPreCreatedBetBuilder {
    '@type': string;
    'pageType': string;
    'sportId': number;
    'title': string;
    'noOfItems': number;
    'displayOrder': number;
    'sortOrder': number;
    'publishedDevices': string[];
    'data'?: PreCreatedBetBuilderData[];
    'sportName'?: string;
}

export interface PreCreatedBetBuilderData {
    '@type': string;
    'segmentOrder': number;
    'pageId': number;
    'moduleTitle': string;
    'prcrComboResponse': PrcrComboResponse;
}

export interface PrcrComboResponse {
    prcrCombos: PrcrCombo[];
}

export interface PrcrCombo {
    '@type': string;
    'segmentOrder': number;
    'pageId': number;
    'moduleTitle': string;
    'prcrComboResponse': PrcrComboResponse;
    'aggregatedPrice': AggregatedPrice;
    'hashId': string;
    'eventId': string;
    'betType': string;
    'bbHashes': BbHash[];
    'events': Event[];
    'cashoutAvailable': boolean;
}

export interface AggregatedPrice {
    decimal: number;
    priceNum: number;
    priceDen: number;
}

export interface BbHash {
    hashId: string;
    aggregatedPrice: AggregatedPrice;
    eventId: string;
}

export interface Event {
    id: string;
    name: string;
    startTime: string;
    liveServChannels: string;
    liveServChildrenChannels: string;
    eventStatusCode: string;
    extIds: string;
    drilldownTagNames: string;
    categoryId: string;
    categoryName: string;
    className: string;
    typeName: string;
    markets: Market[];
}

export interface Market {
    id: string;
    name: string;
    liveServChannels: string;
    marketStatusCode: string;
    drilldownTagNames: string;
    extIds: string;
    outcomes: Outcome[];
}

export interface Outcome {
    outcomeMeaningMajorCode: string;
    outcomeStatusCode: string;
    id: string;
    name: string;
    liveServChannels: string;
    extIds: string;
    prices: Price[];
}

export interface Price {
    id: string;
    priceType: string;
    priceNum: string;
    priceDen: string;
    priceDec: string;
    priceAmerican: string;
    isActive: boolean;
    displayOrder: string;
}

export enum GA_CONSTANTS {
    WIDGET = 'widgets',
    PBB = 'pre created bet builder',
    PBB_WIDGET = 'pre created bet builder widget',
    NOT_APPLICABLE = 'not applicable',
    EXPAND = 'expand',
    COLLAPSE = 'collapse',
    LEFT = 'left',
    RIGHT = 'right',
    NEXT = 'next',
    TRACKING = 'Event.Tracking',
}
export interface IGtmData {
    event: string;
    data: {
        'component.CategoryEvent': string;
        'component.LabelEvent': string;
        'component.ActionEvent': string;
        'component.PositionEvent': string | number;
        'component.LocationEvent': string;
        'component.EventDetails': string;
        'component.URLClicked': string;
    };
}

export interface IPbbData {
    aggregatedPrice: AggregatedPrice;
    betType: string;
    cashoutAvailable: boolean;
    eventId: string;
    events: Event[];
    hashId: string;
    homeDisplayOrder: number;
    isCashoutAvailable: boolean;
    slpDisplayOrder: number;
}
